import { Button } from "@arcadeai/design-system/components/ui/atoms/button";
import {
  Card,
  CardContent,
  CardHeader,
} from "@arcadeai/design-system/components/ui/atoms/card";
import { Skeleton } from "@arcadeai/design-system/components/ui/atoms/skeleton";
import { Plus } from "lucide-react";
import { ListLayout } from "@/components/custom/list-layout/list-layout";

export const LogicExtensionsSkeleton = () => {
  return (
    <ListLayout
      actions={
        <Button disabled size="sm">
          <Plus className="mr-2 size-4" />
          Connect System
        </Button>
      }
      description="Govern what tools users use, verify requests are safe, enrich tool calls with data, and protect sensitive outputs."
      title="Logic Extensions"
    >
      <div className="flex flex-col gap-8">
        {/* Connected Systems Table Skeleton */}
        <Card>
          <CardHeader>
            <Skeleton className="h-6 w-40" />
          </CardHeader>
          <CardContent>
            <div className="rounded-md border">
              {/* Table Header */}
              <div className="flex items-center border-b bg-muted/50 px-4 py-3">
                <Skeleton className="h-4 w-24" />
                <Skeleton className="ml-8 h-4 w-16" />
                <Skeleton className="ml-8 h-4 w-20" />
                <Skeleton className="ml-8 h-4 w-16" />
                <Skeleton className="ml-8 h-4 w-16" />
                <Skeleton className="ml-auto h-4 w-8" />
              </div>
              {/* Table Rows */}
              {[1, 2, 3, 4, 5].map((i) => (
                <div
                  className="flex items-center border-b px-4 py-3 last:border-b-0"
                  key={i}
                >
                  <div className="flex flex-col gap-1">
                    <Skeleton className="h-4 w-40" />
                    <Skeleton className="h-3 w-56" />
                  </div>
                  <Skeleton className="ml-8 h-5 w-20 rounded-full" />
                  <div className="ml-8 flex gap-1">
                    <Skeleton className="size-6 rounded" />
                    <Skeleton className="size-6 rounded" />
                  </div>
                  <Skeleton className="ml-8 h-5 w-16 rounded-full" />
                  <div className="ml-8 flex items-center gap-1.5">
                    <Skeleton className="size-3.5 rounded-full" />
                    <Skeleton className="h-4 w-16" />
                  </div>
                  <Skeleton className="ml-auto size-8 rounded" />
                </div>
              ))}
            </div>
          </CardContent>
        </Card>

        {/* Tabs Skeleton */}
        <div className="flex flex-col gap-4">
          {/* Tab List */}
          <Skeleton className="h-10 w-52 rounded-md" />

          {/* Pipeline Content Skeleton */}
          <Card>
            <CardHeader className="pb-3">
              <div className="flex items-center gap-2">
                <Skeleton className="size-5" />
                <Skeleton className="h-6 w-44" />
              </div>
              <Skeleton className="h-4 w-80" />
            </CardHeader>
            <CardContent>
              <div className="flex items-start gap-4 overflow-x-auto pb-2">
                {/* Request Stage */}
                <div className="flex shrink-0 flex-col items-center gap-2">
                  <Skeleton className="h-10 w-28 rounded-lg" />
                  <Skeleton className="h-3 w-20" />
                </div>
                <Skeleton className="mt-3 size-5" />
                {/* Hook Point Stages */}
                {[1, 2, 3].map((i) => (
                  <div
                    className="flex min-w-[200px] shrink-0 flex-col gap-2"
                    key={i}
                  >
                    <Skeleton className="h-10 w-full rounded-lg" />
                    <div className="flex flex-col gap-1">
                      <Skeleton className="h-4 w-24" />
                      <Skeleton className="h-8 w-full rounded-md" />
                    </div>
                  </div>
                ))}
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </ListLayout>
  );
};
